__turbopack_context__.v({
  "linkItem": "LinkItem-module-scss-module__4x4yRq__linkItem",
});
